import Nullstack from 'nullstack';
export default function IconPhysotherapist({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-physotherapist",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 15l-1 -3l4 -2l4 1h3.5"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "19",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "6",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M12 17v-7"
  }), "   ", Nullstack.element("path", {
    d: "M8 20h7l1 -4l4 -2"
  }), "   ", Nullstack.element("path", {
    d: "M18 20h3"
  }), " ");
}